import React, { useCallback, useEffect, useState } from "react";
import { Marker } from "@react-google-maps/api";
import TreasureInfoCard from "./TreasureInfoCard";
import NearbyTreasureCountCard from "./NearbyTreasureCountCard";

function NearbyTreasuresLayer({ map, userLat, userLng, onReportSuccess }) {
  const [treasures, setTreasures] = useState([]);
  const [selectedTreasure, setSelectedTreasure] = useState(null);
  const [infoCardPosition, setInfoCardPosition] = useState(null);

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

  // 用 useCallback 包裹 fetchNearbyTreasures
  const fetchNearbyTreasures = useCallback(async () => {
    if (userLat && userLng) {
      try {
        const url = `${API_BASE_URL}/api/treasure/nearby?lat=${userLat}&lng=${userLng}&radius=2000`;
        const resp = await fetch(url);
        const text = await resp.text();
        if (!resp.ok) {
          throw new Error(`API error: ${resp.status} - ${text}`);
        }
        let data;
        try {
          data = JSON.parse(text);
        } catch (jsonErr) {
          console.error("Failed to parse JSON. Raw response:", text);
          throw new Error("Invalid JSON response from API");
        }
        if (data.treasures) setTreasures(data.treasures);
      } catch (e) {
        console.error("Failed to fetch nearby treasures", e);
      }
    }
  }, [userLat, userLng, API_BASE_URL]);

  // useEffect 依賴 fetchNearbyTreasures
  useEffect(() => {
    fetchNearbyTreasures();
  }, [fetchNearbyTreasures]);

  // 在地圖上渲染 marker
  return (
    <>
      <NearbyTreasureCountCard count={treasures.length} />
      {treasures.map((t, idx) => {
        const lat = Number(t.lat);
        const lng = Number(t.lng);
        if (isNaN(lat) || isNaN(lng)) {
          console.warn("Invalid treasure lat/lng:", t);
          return null;
        }
        return (
          <Marker
            key={t.id || idx}
            position={{ lat, lng }}
            icon={{
              url: "/treasure.svg",
              scaledSize: { width: 32, height: 32 },
            }}
            onClick={(event) => {
              setSelectedTreasure(null);
              setInfoCardPosition(null);
              setTimeout(() => {
                setSelectedTreasure(t);
                if (event && event.domEvent) {
                  setInfoCardPosition({
                    x: event.domEvent.clientX,
                    y: event.domEvent.clientY,
                  });
                }
              }, 0);
            }}
          />
        );
      })}
      <TreasureInfoCard
        key={selectedTreasure?.id}
        treasure={selectedTreasure}
        position={infoCardPosition}
        onClose={() => {
          setSelectedTreasure(null);
          setInfoCardPosition(null);
        }}
        onReportSuccess={(result) => {
          console.log("[NearbyTreasuresLayer] onReportSuccess result:", result);
          if (!result || result.status !== "success") {
            alert("尋寶回報失敗：" + (result?.error || "未知錯誤"));
          } else {
            fetchNearbyTreasures(); // 回報成功後自動刷新
            if (onReportSuccess) onReportSuccess(result); // 通知父層顯示成功提示 UI
          }
        }}
      />
    </>
  );
}

export default NearbyTreasuresLayer;
